import { render, staticRenderFns } from "./PanelOrganizations.vue?vue&type=template&id=061501ee&lang=pug&"
import script from "./PanelOrganizations.vue?vue&type=script&lang=js&"
export * from "./PanelOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports